// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"styles_layoutContainer__1jQjx","headerContainer":"styles_headerContainer__HACzD","formContentContainer":"styles_formContentContainer__2JEws"};